<template>
	<div class="page">
		<el-image class="pbg" :src="require('@/static/icon30.png')"></el-image>
		<div class="pagecon animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<el-image class="logo" :src="require('@/static/icon31.png')"></el-image>
			<p class="t1">海南省燃气从业人员培训教育查询系统</p>
			<p class="t2">HAINAN PROVINCE GAS CONTINUING EDUCATION INQUIRY SYSTEM</p>
		</div>
		<div class="seachBox animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<div class="seach f-ct">
				<el-image :src="require('@/static/icon32.png')"></el-image>
				<el-input type="text" v-model="keyword" placeholder="请输入搜索关键词"></el-input>
				<div class="submit" @click="memberCertificateSearch">查询</div>
			</div>
			<div class="Table" v-for="(item,index) in pageMsg">
				<div class="f-ct">
					<div class="t1">学员姓名</div>
					<div class="t3">{{item.name}}</div>
				</div>
				<div class="f-ct">
					<div class="t2">证书编号</div>
					<div class="t3">{{item.certificateNumber}}</div>
				</div>
				<div class="f-ct">
					<div class="t1">培训课程</div>
					<div class="t3">{{item.course.name}}</div>
				</div>
				<div class="f-ct">
					<div class="t2">课程类型</div>
					<div class="t3">{{item.course.categoryName}}</div>
				</div>
				<div class="f-ct">
					<div class="t1">所在班级</div>
					<div class="t3">{{item.courseClass.name}}</div>
				</div>
				<div class="f-ct">
					<div class="t2">证书获取时间</div>
					<div class="t3">{{quSFM(item.createTime)}}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { memberCertificateSearch } from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			keyword:'',
			pageMsg:'',
		}
	},
	mounted() {
		
	},
	methods:{
		// 文章详情
		async memberCertificateSearch(){
			let res = await memberCertificateSearch({keyword:this.keyword});
			if(res.code==200){
				this.pageMsg = res.data
			}else{this.Tips(res.msg,'error')}
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.page{
	width: 100%;
	min-height: 718px;
	padding-bottom: 40px;
	.pbg{
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
	}
	.pagecon{
		position: relative;
		z-index: 2;
		padding-top: 60px;
		.logo{
			width: 104px;
			height: 98px;
			display: block;
			margin: auto;
			margin-bottom: 16px;
		}
		.t1{
			font-size: 38px;
			color: #2F3541;
			text-align: center;
		}
		.t2{
			font-size: 12px;
			color: #000000;
			text-align: center;
			margin-bottom: 26px;
			margin-top: 8px;
		}
	}
}
.seachBox{
	width: 692px;
	margin: auto;
	background: #ECF3FC99;
	padding: 10px;
	.seach{
		width: 100%;
		height: 46px;
		background: #fff;
		border: 2px solid #3B6492;
		padding-left: 4px;
		.el-image{
			width: 24px;
			height: 24px;
		}
		.el-input{
			width: 559px;
		}
		::v-deep .el-input__inner{
			border: none;
			padding-left: 0;
			background: transparent;
		}
		.submit{
			cursor: pointer;
			width: 81px;
			color: #fff;
			background: #3B6492;
			font-size: 14px;
			text-align: center;
			line-height: 42px;
		}
	}
	.Table{
		margin-top: 12px;
		.f-ct{
			border-bottom: 1px solid #EBEEF5;
			align-items: stretch;
			.t1{
				background: #FAFBFF;
				width: 180px;
				font-size: 14px;
				min-height: 47px;
				line-height: 47px;
				text-align: center;
				color: #545964;
			}
			.t2{
				background: #F5F8FF;
				width: 180px;
				font-size: 14px;
				color: #545964;
				min-height: 47px;
				line-height: 47px;
				text-align: center;
			}
			.t3{
				border-left: 1px solid #EBEEF5;
				width: calc(100% - 180px);
				min-height: 47px;
				line-height: 47px;
				background: #fff;
				padding-left: 24px;
				font-size: 14px;
				padding-right: 24px;
				color: #666;
			}
		}
	}
}
</style>